<template>
    <div class="webcastsRisk"></div>
</template>

<script>
export default {
    name: 'webcastsRisk',
    props:{
        pondsid:Number
    },
    data() {
        return {
            myChart: null,
            xData:[],
            yData:[]
        }
    },
    methods: {
        setData(){
            this.request.get("/api/Echart/getWeight",{
                params: {
                    pondsid:this.pondsid,
                    number:10
                }
            }).then(res => {
                if(res.code == 200){
                    let data = res.data;
                    this.xData = data.map(item =>{ // 假设 item.time 是 "2024-03-30T10:03:47"
                    const dateParts = item.time.split('-');
                    const month = dateParts[1];
                    const day = dateParts[2].split('T')[0];
                    return `${month}-${day}`;});
                    this.yData = data.map(item => item.weight)
                }
                this.setWebcasts()
            })
        },
        setWebcasts() {
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    backgroundColor: '#11367a',
                    textStyle: {
                        color: '#6dd0e3',
                        fontSize: 10,
                    },
                },
                grid: {
                    top: '12%',
                    bottom: '12%',
                    left: '8%',
                    right: '5%',
                },
                legend: {
                    right: '5%',
                    top: '10%',
                    itemWidth: 7,
                    itemHeight: 7,
                    textStyle: {
                        color: '#fff',
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10,
                    },
                    axisLine: {
                        symbol: ['none', 'arrow'],
                        symbolSize: [6, 6],
                        symbolOffset: [0, 5],
                        lineStyle: {
                            color: '#122C49'
                        }
                    },
                    axisTick: {
                        color: '#122C49',
                        inside: true
                    },
                    z: 2,
                    data: this.xData
                },
                yAxis:
                    {
                        type: 'value',
                        // splitNumber: 8,
                        axisLine: {
                            symbol: ['none', 'arrow'],
                            symbolSize: [6, 6],
                            lineStyle: {
                                color: '#122C49'
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            showMaxLabel: false,
                            fontSize: 10
                        },
                        splitLine: {
                            show: false,
                        },
                        name: '(g)',
                        nameGap: -10,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 9,
                            align: 'right',
                            padding: [0, 6, 0, 0]
                        },
                    },

                series: [{
                    name: '平均体重',
                    type: 'line',
                    symbol: 'none',
                    data: this.yData,
                    lineStyle: {
                        width: 1,
                        color:{
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#0088a9' // 0% 处的颜色
                            },
                            {
                                offset: 1, color: '#ebf5ee' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        } //背景渐变色
                    },
                    itemStyle: {
                        color: '#ebf5ee'
                    },
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#0088a9' // 0% 处的颜色
                            },
                            {
                                offset: 1, color: ' #ebf5ee' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }, //背景渐变色
                        origin: 'start'
                    }
                },
                ]
            };
            if (!this.myChart) this.myChart = this.$echarts(this.$el);

            this.myChart.clear();
            this.myChart.resize();
            this.myChart.setOption(option);
        },
    },
    mounted() {
        this.setData()
    },
    watch: {
        pondsid() {
            this.setData()
        }
    }
}
</script>

<style lang="less" scoped>
.webcastsRisk {
    margin-top: 5%;
    height: 90%;
}
</style>
